import React, { useState, useEffect } from 'react';
import { FormCheckbox, InPageAlert, SectionPage, Row, Col } from '@snsw/react-component-library';
import { useDispatch, useSelector } from 'react-redux';
import { scrollToError, validate } from '../../../shared/utils/Validation';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import styles from './PlantDesignDeclaration.module.scss';
import { useNavigate } from 'react-router-dom';
import { PagePath } from 'shared/constants/pagePath';
import { getFullname } from 'shared/utils/Helpers';
import moment from 'moment';
import { clearPlantDesignDeclaration, storePlantDesignDeclaration } from 'plantDesign/redux/designDeclarationSlice';
import { PlantDesignDeclarationPage } from 'plantDesign/constants/plantDesignDeclarationPage';
import ReactMarkdown from 'react-markdown';
import { PasswordlessContinueSaveExitButtons } from 'shared/components/formNavigationButtons/PasswordlessContinueSaveExitButtons';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

export const PlantDesignDeclaration = (props) => {
  ScrollToTop();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const applicantDetails = useSelector((state) => state.plantDesignApplicantDetails);
  const declaration = useSelector((state) => state.plantDesignDeclaration);

  //todo: get fullname from design applicant details state
  let fullname = getFullname(applicantDetails.firstName, applicantDetails.middleName, applicantDetails.lastName);

  const [agreeDeclaration, setAgreeDeclaration] = useState(declaration.accepted);

  useEffect(() => {
    if (showErrors) validate(validators, setErrors);
  }, [agreeDeclaration]);

  const [showErrors, setShowErrors] = useState(false);

  const validators = [
    {
      fieldName: 'agreeDeclaration',
      fieldValue: agreeDeclaration,
      isValid: () => agreeDeclaration === true,
    },
  ];

  const [errors, setErrors] = useState({
    agreeDeclaration: false,
  });

  const agreementStampText = `I, **${fullname.trim()}**, agree to the above on **${moment().format(
    'Do of MMMM YYYY',
  )}**`;

  const acceptDeclaration = () => {
    dispatch(storePlantDesignDeclaration({ consent: PlantDesignDeclarationPage.consent, stamp: agreementStampText }));
  };

  const onContinueClick = () => {
    if (validate(validators, setErrors)) {
      setShowErrors(false);
      acceptDeclaration();
      navigate(PagePath.plantDesignFees);
    } else {
      setShowErrors(true);
      dispatch(clearPlantDesignDeclaration());
      scrollToError();
    }
  };

  const onPreSavingClick = () => {
    if (validate(validators, setErrors)) {
      acceptDeclaration();
    } else {
      dispatch(clearPlantDesignDeclaration());
    }
  };

  return (
    <>
      <SectionPage>
        <Row>
          <Col span={9} className={styles.declarationItems}>
            <InPageAlert
              className={styles.iconFix}
              variant="warning"
              title={
                <>
                  Note: Making a false or misleading statement, giving false or misleading information, or producing
                  false or misleading documents is a serious offence which may render you liable to prosecution for
                  offences including under the <em>Crimes Act</em> and section 268 of the{' '}
                  <em>Work Health and Safety Act</em> which may result in penalties including a fine or imprisonment.
                </>
              }
            />
            <ReactMarkdown linkTarget={'_blank'}>{PlantDesignDeclarationPage.consent}</ReactMarkdown>
            <div className={styles.margintop24}>
              <FormCheckbox
                errorMessage="Please tick the checkbox"
                hasError={showErrors && errors.agreeDeclaration}
                id="selectionCheckBox"
                label={<ReactMarkdown className={styles.stampText}>{agreementStampText}</ReactMarkdown>}
                name="selectionCheckBox"
                onChange={(v) => {
                  if (v === 'checked') {
                    setAgreeDeclaration(true);
                  } else {
                    setAgreeDeclaration(false);
                  }
                }}
                testId="selectionCheckBox"
                value={'checked'}
                checked={agreeDeclaration}
              />
            </div>
          </Col>
        </Row>
      </SectionPage>

      <SectionPage className={styles.nxtBtns}>
        <PasswordlessContinueSaveExitButtons
          onContinueClick={onContinueClick}
          onPreSaving={onPreSavingClick}
          onBackClick={() => navigate(PagePath.plantDesignReview)}
          licenceType={PlantDesignConstants.licenceType}
        />
      </SectionPage>
    </>
  );
};
